// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bd98369dfbf86373181a7f5b723200b9.bundle.js";
};